export default "__VITE_ASSET__41111295__"